import React from 'react';
import classnames from 'classnames/bind';
import style from './index.module.scss';

const cx = classnames.bind(style);

interface Props {
  className?: string;
}

function Loading(props: Props) {
  const {className} = props;
  return (
    <div data-testid="loading" className={cx('loading', cx(className))}>
      <div className={cx('loading-icon')}></div>
    </div>
  );
}

export default Loading;
